/**
 * What waits for National IT on the National view (DEC-33), in one sentence: open requests from firms, ratings to
 * review, and National IT's position on the BTI Wave 2 items before their due date. Pure, so every combination is
 * unit tested (NEXT PASS 5).
 *
 * Counts with something waiting are said as numbers; nothing waiting is said in words, never as a bare zero. A read
 * that failed is said ("could not be loaded"), never left out (SFH-01). The days left are said once on the page, by
 * the Wave 2 card under this line, so the line gives only the date.
 */
import { BTI_WAVE2_DUE, BTI_WAVE2_ITEMS } from './bti-evaluation.js';
import { longDate } from './leadership.js';
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
export function nationalWorkLine(requests, reviews, wave2Recorded) {
    const parts = [
        { v: requests, one: 'request from firms', many: 'requests from firms' },
        { v: reviews, one: 'rating to review', many: 'ratings to review' },
    ];
    const counted = parts.filter((p) => p.v !== 'failed' && p.v > 0);
    const none = parts.filter((p) => p.v === 0).map((p) => p.many);
    const failed = parts.filter((p) => p.v === 'failed').map((p) => `${p.many} could not be loaded`);
    const total = counted.reduce((a, p) => a + p.v, 0);
    const clauses = [];
    if (counted.length) {
        const said = counted.map((p) => plural(p.v, p.one, p.many)).join(' and ');
        clauses.push(`${said} ${total === 1 ? 'is' : 'are'} waiting${none.length ? `, and no ${none.join(' or ')}` : ''}`);
    }
    else if (none.length) {
        clauses.push(`no ${none.join(' or ')} are waiting`);
    }
    clauses.push(...failed);
    const due = longDate(BTI_WAVE2_DUE);
    const items = BTI_WAVE2_ITEMS.length;
    clauses.push(wave2Recorded === 'failed'
        ? `National IT's Wave 2 positions could not be loaded, and BTI Wave 2 is due ${due}`
        : wave2Recorded === 0
            ? `National IT has not recorded its position on any of the ${items} BTI Wave 2 requirements yet, due ${due}`
            : `National IT has recorded its position on ${wave2Recorded} of ${items} BTI Wave 2 requirements, due ${due}`);
    const line = clauses.join('; ');
    return `${line[0].toUpperCase()}${line.slice(1)}.`;
}
//# sourceMappingURL=national-work.js.map